/**
 * /tenants/$slug/directory — route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import { fetchDirectoryOverview } from "@/features/directory/queries";
import { queryKeys } from "@/lib/query-keys";
import { DirectoryPage } from "@/features/directory/pages/directory-page";

export const Route = createFileRoute("/_authed/tenants/$slug/directory/")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.directory.overview(context.tenant.id),
      queryFn: () => fetchDirectoryOverview(context.tenant.id),
    }),
  component: DirectoryPage,
});
